import { AbstractRouterFilter } from '@zk/framework-vue';

export default class FunctionSwitchFilter extends AbstractRouterFilter {
  order() {
    // 在SSOFilter后执行
    return super.order() + 10;
  }

  matches(to) {
    return to.meta?.functions?.length;
  }

  onBefore(to, from) {
    const { functions, functionAnd = false } = to.meta;
    const isSwitch = this.option.store.getters['features/isSwitch'];
    const isCurrentProjectSwitch = this.option.store.getters['features/isCurrentProjectSwitch'];
    const check = key => isSwitch(key) || isCurrentProjectSwitch(key);
    const hasAccess = functionAnd ? functions.every(check) : functions.some(check);
    if (hasAccess) {
      return true;
    }
    window.console.warn(`functions access denied. to: ${to.path}`);
    if (from.path === '/') {
      return '/';
    }
    return '/kanban/list';
  }
}
